import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Modal from "../UI/Modal";
import { closeResponsePhraseView } from "../../store/reducers/plantels/responsePhrases.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const ResponsePhraseViewModal = () => {
  const dispatch = useDispatch();

  const { viewModalOpen, selectedPhrase, selectedPhraseLoading } = useSelector(
    (state) => state.responsePhrases,
  );

  return (
    <Modal
      open={viewModalOpen}
      title="Detalle frase de respuesta"
      size="lg"
      onClose={() => dispatch(closeResponsePhraseView())}
    >
      {selectedPhraseLoading ? (
        <Loader center />
      ) : selectedPhrase ? (
        <div className="row g-4">
          <div className="col-12">
            <Field
              label="Frase"
              value={selectedPhrase.frase}
              icon="mdi:message-reply-text-outline"
            />
          </div>
          <div className="col-md-6">
            <Field
              icon="mdi:numeric"
              label="Valor"
              value={selectedPhrase.valor}
            />
          </div>
          <div className="col-md-6">
            <Field
              icon="mdi:package-variant"
              label="Paquete de respuesta"
              value={selectedPhrase.paquete_respuesta_nombre || "N/A"}
            />
          </div>
          <div className="col-md-6">
            <Field
              icon="mdi:toggle-switch"
              label="Estado"
              value={
                <span
                  className={`badge ${
                    selectedPhrase.is_active
                      ? "bg-success-focus text-success-main"
                      : "bg-neutral-200 text-neutral-600"
                  } px-3 py-2`}
                >
                  {selectedPhrase.is_active ? "Activo" : "Inactivo"}
                </span>
              }
            />
          </div>
          {selectedPhrase.is_neutral !== undefined && (
            <div className="col-md-6">
              <Field
                icon="mdi:scale-balance"
                label="¿Es neutral?"
                value={
                  <span
                    className={`badge ${
                      selectedPhrase.is_neutral
                        ? "bg-info-focus text-info-main"
                        : "bg-neutral-200 text-neutral-600"
                    } px-3 py-2`}
                  >
                    {selectedPhrase.is_neutral ? "Sí" : "No"}
                  </span>
                }
              />
            </div>
          )}

          {/* Información de auditoría */}
          <div className="col-12">
            <AuditInfo
              createdAt={selectedPhrase.created_at}
              updatedAt={selectedPhrase.updated_at}
              createdBy={selectedPhrase.created_by}
              updatedBy={selectedPhrase.updated_by}
            />
          </div>
        </div>
      ) : null}
    </Modal>
  );
};

export default ResponsePhraseViewModal;
